import React from 'react';
import { useSearchParams } from 'react-router-dom';
import StorefrontLayout from '../components/layout/StorefrontLayout';
import PublicProductsSection from '../components/ui/PublicProductsSection';
import { useDepartmentSlug } from '../utils/departmentRouting';

export default function ProductsCatalogPage() {
  const [searchParams] = useSearchParams();
  const departmentSlug = useDepartmentSlug();
  const q = searchParams.get('q') || '';
  const categorySlug = searchParams.get('category') || '';

  return (
    <StorefrontLayout contentContained={false} mainFlushTop mainClassName="bg-transparent">
      <PublicProductsSection
        mode="catalog"
        initialSearch={q}
        initialCategorySlug={categorySlug}
        departmentSlug={departmentSlug}
      />
    </StorefrontLayout>
  );
}
